import { ArrowUp } from "lucide-react";

import { Shell } from "@/components/wizard/shell";

export function SendScreen({
	hp,
	onHpChange,
	onBack,
	onSubmit,
	pending,
}: {
	hp: string;
	onHpChange: (v: string) => void;
	onBack: () => void;
	onSubmit: () => void;
	pending: boolean;
}) {
	return (
		<Shell>
			<button
				type="button"
				onClick={onBack}
				className="absolute left-6 top-6 -m-3 flex items-center gap-2 p-3 text-base text-muted-foreground hover:text-foreground sm:-m-0 sm:gap-1 sm:p-0 sm:text-sm"
			>
				<ArrowUp className="size-4" />
				voltar
			</button>

			<div className="fade-up w-full max-w-xl text-center">
				<h1 className="font-display text-4xl leading-tight text-foreground">Enviar contato</h1>
				<p className="mt-4 text-xl text-muted-foreground">
					A gente recebe o seu contato na hora e te chama no WhatsApp.
				</p>

				<input
					type="text"
					value={hp}
					onChange={(e) => onHpChange(e.target.value)}
					tabIndex={-1}
					autoComplete="off"
					aria-hidden="true"
					className="sr-only"
				/>

				<button
					type="button"
					onClick={onSubmit}
					disabled={pending}
					className="mt-10 w-full rounded-full bg-primary px-10 py-4 text-xl font-semibold text-primary-foreground shadow-control transition hover:bg-primary-hover disabled:opacity-60"
				>
					{pending && "Enviando contato..."}
					{!pending && "Enviar contato"}
				</button>

				<p className="mt-4 text-sm text-muted-foreground">
					Ao enviar, você aceita que a clínica entre em contato e envie novidades e promoções pelo
					WhatsApp informado.
				</p>
			</div>
		</Shell>
	);
}
